import React from 'react';

interface MetricCardProps {
  label: string;
  value: string;
  tone?: 'default' | 'positive' | 'warning';
  helper?: string;
  variant?: 'default' | 'dashboard';
  theme?: 'default' | 'rake' | 'balance' | 'deposit' | 'fee' | 'receivable' | 'payable' | 'warning';
  badge?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  tone = 'default',
  helper,
  variant = 'default',
  theme = 'default',
  badge,
}) => {
  return (
    <article className={`metric-card metric-card--${tone} metric-card--${variant} metric-card--theme-${theme}`}>
      <div className="metric-card__header">
        <span className="metric-card__label">{label}</span>
        {badge ? <span className="metric-card__badge">{badge}</span> : null}
      </div>
      <strong className="metric-card__value">{value}</strong>
      {helper ? <span className="metric-card__helper">{helper}</span> : null}
    </article>
  );
};

export default MetricCard;
